import { render, staticRenderFns } from "./SplitSectionPage.vue?vue&type=template&id=14f98da2&"
import script from "./SplitSectionPage.vue?vue&type=script&lang=js&"
export * from "./SplitSectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports